export const FeatureFlagState = {
	OFF: 'off',
	LOCAL: 'local',
	DEV: 'dev',
	ON: 'on',
} as const;
export type FeatureFlagState =
	(typeof FeatureFlagState)[keyof typeof FeatureFlagState];

export type FeatureFlagEnvironment = 'local' | 'dev' | 'production';

// Higher rank = further along toward production. A flag is enabled when its
// state's rank is >= the current environment's rank, which is what makes the
// tiers cumulative (off < local < dev < on).
export const FEATURE_FLAG_ENVIRONMENT_RANK: Record<
	FeatureFlagEnvironment,
	number
> = {
	local: 0,
	dev: 1,
	production: 2,
};

export const FEATURE_FLAG_STATE_RANK: Record<FeatureFlagState, number> = {
	[FeatureFlagState.OFF]: -1,
	[FeatureFlagState.LOCAL]: 0,
	[FeatureFlagState.DEV]: 1,
	[FeatureFlagState.ON]: 2,
};
